import { ArrowUpRight, Coffee, Apple, ShoppingBasket, Shirt } from "lucide-react";
import Reveal from "../Reveal";

const CAFE        = "https://images.unsplash.com/photo-1556745750-68295fefafc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxjYWZlJTIwcmVzdGF1cmFudCUyMGNvdW50ZXIlMjBQT1N8ZW58MHx8fHwxNzc4MjU0MDk3fDA&ixlib=rb-4.1.0&q=85";
const GROCERY     = "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1200&q=80";
const SUPERMARKET = "https://images.unsplash.com/photo-1601598851547-4302969d0614?auto=format&fit=crop&w=1200&q=80";
const RETAIL      = "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80";

const industries = [
  { title: "Cafes & Restaurants", icon: Coffee,         img: CAFE,        desc: "Manage orders, billing & inventory efficiently." },
  { title: "Grocery Stores",      icon: Apple,          img: GROCERY,     desc: "Track stock, expiry & sales effortlessly." },
  { title: "Supermarkets",        icon: ShoppingBasket, img: SUPERMARKET, desc: "Handle large inventory & bulk billing." },
  { title: "Retail Shops",        icon: Shirt,          img: RETAIL,      desc: "Simplify billing & grow your business." },
];

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="relative py-24 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <Reveal>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-navy">
              Perfect for Every Business
            </h2>
          </Reveal>
          <Reveal delay={100}>
            <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
              From a single counter to multi-branch chains — FolioStax adapts to your shop.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((it, i) => (
            <Reveal key={it.title} delay={(i % 3) * 80}>
              <a
                href="#contact"
                data-testid={`industry-card-${i}`}
                className="group flex flex-col rounded-2xl overflow-hidden bg-white border border-slate-200 hover:border-blue-700/40 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-slate-100">
                  <img
                    src={it.img}
                    alt={it.title}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-6 flex items-start justify-between gap-4 flex-1">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <it.icon className="h-4 w-4 text-blue-800" />
                      <h3 className="font-display font-bold text-lg text-navy tracking-tight">
                        {it.title}
                      </h3>
                    </div>
                    <p className="text-sm text-slate-600 leading-relaxed">{it.desc}</p>
                  </div>
                  <span className="h-9 w-9 shrink-0 rounded-full border border-slate-200 grid place-items-center group-hover:bg-navy group-hover:border-navy transition-colors">
                    <ArrowUpRight className="h-4 w-4 text-slate-700 group-hover:text-white transition-colors" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
